if (!customElements.get('load-more')) {
  customElements.define(
    'load-more',
    class LoadMore extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.loadMoreButton = this.querySelector('.js-load-more');
        this.loadMoreDisabledButton = this.querySelector('.js-load-more-disabled');
        this.paginationWrapper = this.closest('.pagination-wrapper');
        this.pagination = document.querySelector('.pagination');
        this.containerWrapperSelector = this.paginationWrapper.closest('[data-container-wrapper]');
        this.containerSelector = this.containerWrapperSelector.querySelector('[data-container]');
        
        const urlParams = new URLSearchParams(window.location.search);
        this.currentPage = parseInt(urlParams.get('page')) || 1;
        
        this.totalPages = this.extractTotalPages();

        if (this.loadMoreButton) {
          this.loadMoreButton.addEventListener('click', () => this.loadMoreProducts());
        }
      }

      loadMoreProducts() {
        const nextPageUrl = this.getNextPageUrl();
        if (!nextPageUrl) return;

        fetch(nextPageUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
          })
          .then((responseHTML) => {
            const parser = new DOMParser();
            const html = parser.parseFromString(responseHTML, 'text/html');
            const newItems = Array.from(html.querySelector('[data-container]').children);

            newItems.forEach((item) => this.containerSelector.appendChild(item));

            this.currentPage++;

            const newNextPageUrl = this.getNextPageUrl(html);
            this.updateNextPageState(newNextPageUrl);
            this.updatePaginationElements(html);
            this.updateCollectionHeading();
            
            this.updateBrowserUrl();
          })
          .catch((error) => console.error('Error loading more products:', error));
      }

      getNextPageUrl(doc = document) {
        const nextLink = doc.querySelector('.js-pagination-next');
        return nextLink ? nextLink.getAttribute('href') : null;
      }

      updatePaginationElements(html) {
        const newPagination = html.querySelector('.pagination');
        this.pagination.innerHTML = newPagination.innerHTML;
        
        const newTotalPages = this.extractTotalPages(newPagination);
        if (newTotalPages) {
          this.totalPages = newTotalPages;
        }
      }

      updateNextPageState(nextPageUrl) {
        if (nextPageUrl) {
          this.loadMoreButton.classList.remove('hidden');
          this.loadMoreDisabledButton.classList.add('hidden');
        } else {
          this.loadMoreButton.classList.add('hidden');
          this.loadMoreDisabledButton.classList.remove('hidden');
        }
      }

      updateBrowserUrl() {
        const currentUrl = new URL(window.location.href);
        
        if (this.currentPage > 1) {
          currentUrl.searchParams.set('page', this.currentPage.toString());
        } else {
          currentUrl.searchParams.delete('page');
        }
        
        currentUrl.searchParams.delete('phcursor');
        
        window.history.pushState({ page: this.currentPage }, '', currentUrl.toString());
      }

      updateCollectionHeading() {
        // Try multiple selectors to find the heading
        const headingSelectors = [
          '.collection-page-title h1',
          '.collection-page-title', 
          'h1.collection-page-title',
          '[class*="collection-page-title"]'
        ];
        
        let headingElements = [];
        for (const selector of headingSelectors) {
          headingElements = document.querySelectorAll(selector);
          if (headingElements.length > 0) break;
        }
        
        if (headingElements.length === 0) {
          return;
        }
        
        const firstHeading = headingElements[0];
        let baseTitle = firstHeading.textContent || firstHeading.innerText || '';
        
        const originalTitle = baseTitle;
        
        baseTitle = baseTitle.replace(/\s+/g, ' ').trim();
        
        baseTitle = baseTitle.replace(/\s*-\s*Strana\s+\d+\s+z\s+\d+/gi, '').trim();
        
        let newTitle = baseTitle;
        if (this.currentPage > 1) {
          if (this.totalPages) {
            newTitle = `${baseTitle} - Strana ${this.currentPage} z ${this.totalPages}`;
          } else {
            newTitle = `${baseTitle} - Strana ${this.currentPage}`;
          }
        }
        
        headingElements.forEach(heading => {
          heading.textContent = newTitle;
        });
      }

      extractTotalPages(paginationContainer = document) {
        const paginationInfo = paginationContainer.querySelector('.pagination__summary');
        if (paginationInfo) {
          const match = paginationInfo.textContent.match(/z (\d+)/);
          if (match) {
            return parseInt(match[1]);
          }
        }

        const infoElements = paginationContainer.querySelectorAll('.pagination__info, .pagination-info, [class*="pagination"][class*="info"]');
        for (const element of infoElements) {
          const match = element.textContent.match(/z (\d+)|of (\d+)/i);
          if (match) {
            const total = match[1] || match[2];
            return parseInt(total);
          }
        }

        const pageLinks = paginationContainer.querySelectorAll('.pagination__item[href]');
        let maxPage = 1;
        pageLinks.forEach(link => {
          const href = link.getAttribute('href');
          const match = href.match(/[?&]page=(\d+)/);
          if (match) {
            maxPage = Math.max(maxPage, parseInt(match[1]));
          }
        });
        
        if (maxPage > 1) {
          return maxPage;
        }

        const lastLink = paginationContainer.querySelector('.pagination__item--last[href]');
        if (lastLink) {
          const match = lastLink.getAttribute('href').match(/[?&]page=(\d+)/);
          if (match) {
            return parseInt(match[1]);
          }
        }

        return null;
      }
    },
  );
}
